import styled from "styled-components/macro";

import { ReactComponent as CloseSvg } from "./close.svg";

export const CloseIcon = styled(CloseSvg)`
  display: block;
`;
